import { ConstructionSiteFieldsFragment } from 'generated/graphql';
import { db } from 'technical/db';
import logger from 'technical/logger';

export async function persistConstructionSiteListInLocalStorage(
  sites: ConstructionSiteFieldsFragment[],
): Promise<void> {
  await db.constructionSiteList.put({ id: 'singleton', sites });
}

export async function fetchConstructionSiteListFromLocalStorage(): Promise<
  ConstructionSiteFieldsFragment[] | null
> {
  try {
    const record = await db.constructionSiteList.get('singleton');
    return record?.sites ?? null;
  } catch (err) {
    logger.error(err);
    return null;
  }
}
